export default "__VITE_ASSET__Bh0a39kw__"